export const companies = {
  en: {
    title: "Companies",
    subtitle: "Manage your company accounts and relationships",
    addCompany: "Add Company",
    totalCompanies: "Total Companies",
    active: "Active",
    hoursPurchased: "Hours Purchased",
    hoursUsed: "Hours Used",
    searchCompanies: "Search companies...",
    searchAriaLabel: "Search companies by name or email",
    filterByStatus: "Filter by status",
    filterByIndustry: "Filter by industry",
    allStatus: "All Status",
    allIndustries: "All Industries",
    companyList: "Company List",
    companyStatistics: "Company Statistics",
    company: "Company",
    industry: "Industry",
    status: "Status",
    hours: "Hours",
    startDate: "Start Date",
    tags: "Tags",
    actions: "Actions",
    viewDetails: "View Details",
    inviteUser: "Invite User",
    editCompany: "Edit Company",
    deleteCompany: "Delete Company",
    loadingCompanies: "Loading companies...",
    noCompaniesFound: "No companies found",
    noMatchingFilters: "No companies found matching your filters.",
    noResultsFor: "No results found for",
    tryAdjusting: "Try adjusting your search or filters",
    sendInvitation: "Send Invitation",
    inviteDesc: "Invite a user to this company",
    emailRequired: "Email is required",
    invalidEmail: "Invalid email address",
    invitationsValid: "Invitations are valid for 7 days",
    sentInvitation: "Sent invitation to",
    failedInvitation: "Failed to send invitation",
    unexpectedError: "An unexpected error occurred",
    deleteConfirmation: "Delete Confirmation",
    deleteConfirmDesc: "This will permanently delete the company and all associated data. This action cannot be undone.",
    deleteConfirmQuestion: "Are you sure you want to delete",
    cannotBeUndone: "This action cannot be undone.",
    failedDelete: "Failed to delete company",
    addCompanyDesc: "Create a new company account.",
    nameRequired: "Name is required",
    companyName: "Company Name",
    enterCompanyName: "Enter company name",
    totalHoursPurchased: "Total Hours Purchased",
    leaveBlankUnlimited: "Leave blank for unlimited",
    allFieldsRequired: "All fields except total hours are required",
    optional: "Optional",
    paused: "Paused",
    completed: "Completed",
    churned: "Churned",
    saveChanges: "Save Changes",
    updateCompanyInfo: "Update company information and settings.",
    hoursUsedLabel: "Hours Used",
    tableCaption: "List of companies with their details including industry, status, hours, and actions",
    // Industries
    industries: {
      technology: "Technology",
      healthcare: "Healthcare",
      finance: "Finance",
      retail: "Retail",
      education: "Education",
      manufacturing: "Manufacturing",
      real_estate: "Real Estate",
      hospitality: "Hospitality",
      food_beverage: "Food & Beverage",
      professional_services: "Professional Services",
      nonprofit: "Non-profit",
      pharmacy: "Pharmacy",
      brand: "Brand",
      distributor: "Distributor",
      agency: "Agency",
      other: "Other",
    },
    // Statuses
    statuses: {
      active: "Active",
      paused: "Paused",
      completed: "Completed",
      churned: "Churned",
    },
    // Invite dialog
    invite: {
      title: "Invite User",
      sendMagicLink: "Send a magic link invitation to give someone access to",
      thisCompany: "this company",
      portal: "'s portal.",
      inviteCompanyTitle: "Invite Company",
      sendMagicLinkCompany: "Send a magic link invitation to give",
      accessPortal: "access to their company portal.",
      created: "Invitation created! Share this link with the user.",
      createdCompany: "Invitation created! Share this link with the company.",
      linkLabel: "Invitation Link",
      expiresIn: "This link expires in 7 days",
      done: "Done",
      emailAddress: "Email Address",
      personalMessage: "Personal Message",
      optionalLabel: "(optional)",
      messagePlaceholder: "Welcome to your company portal...",
      creating: "Creating...",
      copyUrl: "Copy invitation URL",
      addExistingUser: "Add Existing User",
      searchUsers: "Search by name or email...",
      noUsersFound: "No users found",
      noAvailableUsers: "All existing users are already in this company",
      addToCompany: "Add",
      addingUser: "Adding...",
      inviteNew: "Invite New",
      currentCompany: "Currently in",
      noCompany: "No company",
    },
    // Company detail page
    companyDetails: "Company Details",
    loadingDetails: "Loading company details...",
    companyNotFound: "Company not found",
    failedToLoad: "Failed to load company",
    backToCompanies: "Back to Companies",
    overview: "Overview",
    tickets: "Tickets",
    notes: "Notes",
    activity: "Activity",
    files: "Files",
    kanban: "Kanban",
    editLabel: "Edit",
    // Detail page stats
    ofHoursUsed: "of {total}h used",
    ofTasksDone: "of {total} tasks done",
    setCurrentPhase: "Set current phase",
    phaseOf: "Phase {current} of {total}",
    daysRemaining: "days remaining",
    dueToday: "due today",
    daysOverdue: "days overdue",
    noTargetDate: "No target date set",
    daysLeft: "days left",
    notSet: "Not set",
    phase: "Phase",
    // Contact & profile
    contactInformation: "Contact Information",
    contactName: "Contact Name",
    email: "Email",
    phone: "Phone",
    website: "Website",
    portalUsers: "Portal Users",
    unnamedUser: "Unnamed User",
    removeUser: "Remove User",
    removeUserConfirm: "Remove from company?",
    removeUserDesc: "This will unlink their account from this company. They will lose access to the client portal.",
    userRemoved: "User removed from company",
    teamAssigned: "Team Assigned",
    unknown: "Unknown",
    companyProfile: "Company Profile",
    fromRequest: "From Request",
    requestSubmitted: "Request Submitted",
    started: "Started",
    target: "Target",
    // Edit dialog
    editDialog: {
      title: "Edit Company",
      description: "Update company information and project settings.",
      industry: "Industry",
      selectIndustry: "Select industry",
      notSpecified: "Not specified",
      contactEmail: "Contact Email",
      status: "Status",
      selectStatus: "Select status",
      archived: "Archived",
      hoursPurchased: "Hours Purchased",
      startDate: "Start Date",
      targetCompletion: "Target Completion",
      currentPhase: "Current Phase",
      selectPhase: "Select phase",
      notSetPhase: "Not set",
    },
    // Tabs
    projectsTab: "Projects",
    brandTab: "Brand",
    socialTab: "Social",
    scopingTab: "Scoping",
    discoveryTab: "Discovery",
    noProjectsForCompany: "No projects yet",
    createProjectHint: "Create a project to start tracking work for this company.",
    manageBrandAssets: "Manage Brand Assets",
    brandAssetsHint: "Edit brand guidelines, colors, typography, and visual identity for this company.",
    manageSocialMedia: "Manage Social Media",
    socialMediaHint: "Create and schedule social media content for this company.",
    // Service request
    serviceRequest: "Service Request",
    serviceRequestCreatedFrom: "This company was created from a service request",
    submitted: "Submitted",
    viewRequest: "View Request",
    // Company profile (client view)
    profile: {
      title: "Company Profile",
      subtitle: "View and manage company information",
      notLinked: "Account Not Linked",
      notLinkedDesc: "Your account is not yet linked to a company profile. Please contact support to complete your account setup.",
      goToRequests: "Go to My Requests",
      noCompanies: "No companies found.",
      selectCompany: "Select company",
      companyInfo: "Company Information",
      editDetails: "Edit Details",
      contactEmail: "Contact Email",
      created: "Created",
      serviceHours: "Service Hours",
      purchased: "Purchased",
      used: "Used",
      remaining: "Remaining",
      unlimited: "Unlimited",
      notAvailable: "N/A",
      usage: "Usage",
      quickLinks: "Quick Links",
      brandAssets: "Brand Assets",
      brandAssetsDesc: "Logos, colors, typography",
      executions: "Executions",
      executionsDesc: "Tasks and deliverables",
      socialMedia: "Social Media",
      socialMediaDesc: "Content and scheduling",
      addTag: "Add tag...",
      noTags: "No tags added",
      loading: "Loading company profile",
      companyName: "Company Name",
    },
  },
  es: {
    title: "Empresas",
    subtitle: "Gestiona tus cuentas de empresas y relaciones",
    addCompany: "Agregar Empresa",
    totalCompanies: "Total Empresas",
    active: "Activas",
    hoursPurchased: "Horas Compradas",
    hoursUsed: "Horas Usadas",
    searchCompanies: "Buscar empresas...",
    searchAriaLabel: "Buscar empresas por nombre o correo",
    filterByStatus: "Filtrar por estado",
    filterByIndustry: "Filtrar por industria",
    allStatus: "Todos los Estados",
    allIndustries: "Todas las Industrias",
    companyList: "Lista de Empresas",
    companyStatistics: "Estadísticas de Empresas",
    company: "Empresa",
    industry: "Industria",
    status: "Estado",
    hours: "Horas",
    startDate: "Fecha de Inicio",
    tags: "Etiquetas",
    actions: "Acciones",
    viewDetails: "Ver Detalles",
    inviteUser: "Invitar Usuario",
    editCompany: "Editar Empresa",
    deleteCompany: "Eliminar Empresa",
    loadingCompanies: "Cargando empresas...",
    noCompaniesFound: "No se encontraron empresas",
    noMatchingFilters: "No se encontraron empresas con los filtros aplicados.",
    noResultsFor: "No se encontraron resultados para",
    tryAdjusting: "Intenta ajustar tu búsqueda o filtros",
    sendInvitation: "Enviar Invitación",
    inviteDesc: "Invitar a un usuario a esta empresa",
    emailRequired: "El correo es requerido",
    invalidEmail: "Dirección de correo inválida",
    invitationsValid: "Las invitaciones son válidas por 7 días",
    sentInvitation: "Invitación enviada a",
    failedInvitation: "Error al enviar la invitación",
    unexpectedError: "Ocurrió un error inesperado",
    deleteConfirmation: "Confirmar Eliminación",
    deleteConfirmDesc: "Esto eliminará permanentemente la empresa y todos los datos asociados. Esta acción no se puede deshacer.",
    deleteConfirmQuestion: "¿Estás seguro de que deseas eliminar",
    cannotBeUndone: "Esta acción no se puede deshacer.",
    failedDelete: "Error al eliminar la empresa",
    addCompanyDesc: "Crea una nueva cuenta de empresa.",
    nameRequired: "El nombre es requerido",
    companyName: "Nombre de Empresa",
    enterCompanyName: "Ingresa el nombre de la empresa",
    totalHoursPurchased: "Total Horas Compradas",
    leaveBlankUnlimited: "Dejar en blanco para ilimitado",
    allFieldsRequired: "Todos los campos excepto las horas totales son requeridos",
    optional: "Opcional",
    paused: "Pausada",
    completed: "Completada",
    churned: "Finalizada",
    saveChanges: "Guardar Cambios",
    updateCompanyInfo: "Actualiza la información y configuración de la empresa.",
    hoursUsedLabel: "Horas Usadas",
    tableCaption: "Lista de empresas con sus detalles incluyendo industria, estado, horas y acciones",
    // Industries
    industries: {
      technology: "Tecnología",
      healthcare: "Salud",
      finance: "Finanzas",
      retail: "Retail",
      education: "Educación",
      manufacturing: "Manufactura",
      real_estate: "Bienes Raíces",
      hospitality: "Hospitalidad",
      food_beverage: "Alimentos y Bebidas",
      professional_services: "Servicios Profesionales",
      nonprofit: "Sin Fines de Lucro",
      pharmacy: "Farmacia",
      brand: "Marca",
      distributor: "Distribuidor",
      agency: "Agencia",
      other: "Otro",
    },
    // Statuses
    statuses: {
      active: "Activa",
      paused: "Pausada",
      completed: "Completada",
      churned: "Finalizada",
    },
    // Invite dialog
    invite: {
      title: "Invitar Usuario",
      sendMagicLink: "Envía un enlace mágico para dar acceso al portal de",
      thisCompany: "esta empresa",
      portal: ".",
      inviteCompanyTitle: "Invitar Empresa",
      sendMagicLinkCompany: "Envía un enlace mágico para dar acceso a",
      accessPortal: "al portal de su empresa.",
      created: "¡Invitación creada! Comparte este enlace con el usuario.",
      createdCompany: "¡Invitación creada! Comparte este enlace con la empresa.",
      linkLabel: "Enlace de Invitación",
      expiresIn: "Este enlace expira en 7 días",
      done: "Listo",
      emailAddress: "Correo Electrónico",
      personalMessage: "Mensaje Personal",
      optionalLabel: "(opcional)",
      messagePlaceholder: "Bienvenido al portal de tu empresa...",
      creating: "Creando...",
      copyUrl: "Copiar URL de invitación",
      addExistingUser: "Agregar Usuario Existente",
      searchUsers: "Buscar por nombre o correo...",
      noUsersFound: "No se encontraron usuarios",
      noAvailableUsers: "Todos los usuarios existentes ya están en esta empresa",
      addToCompany: "Agregar",
      addingUser: "Agregando...",
      inviteNew: "Invitar Nuevo",
      currentCompany: "Actualmente en",
      noCompany: "Sin empresa",
    },
    // Company detail page
    companyDetails: "Detalles de Empresa",
    loadingDetails: "Cargando detalles de empresa...",
    companyNotFound: "Empresa no encontrada",
    failedToLoad: "Error al cargar la empresa",
    backToCompanies: "Volver a Empresas",
    overview: "Resumen",
    tickets: "Tickets",
    notes: "Notas",
    activity: "Actividad",
    files: "Archivos",
    kanban: "Kanban",
    editLabel: "Editar",
    // Detail page stats
    ofHoursUsed: "de {total}h usadas",
    ofTasksDone: "de {total} tareas completadas",
    setCurrentPhase: "Establecer fase actual",
    phaseOf: "Fase {current} de {total}",
    daysRemaining: "días restantes",
    dueToday: "vence hoy",
    daysOverdue: "días de retraso",
    noTargetDate: "Sin fecha objetivo",
    daysLeft: "días restantes",
    notSet: "No establecido",
    phase: "Fase",
    // Contact & profile
    contactInformation: "Información de Contacto",
    contactName: "Nombre de Contacto",
    email: "Correo",
    phone: "Teléfono",
    website: "Sitio Web",
    portalUsers: "Usuarios del Portal",
    unnamedUser: "Usuario sin Nombre",
    removeUser: "Eliminar Usuario",
    removeUserConfirm: "Eliminar de la empresa?",
    removeUserDesc: "Esto desvinculará su cuenta de esta empresa. Perderá acceso al portal del cliente.",
    userRemoved: "Usuario eliminado de la empresa",
    teamAssigned: "Equipo Asignado",
    unknown: "Desconocido",
    companyProfile: "Perfil de Empresa",
    fromRequest: "Desde Solicitud",
    requestSubmitted: "Solicitud Enviada",
    started: "Iniciado",
    target: "Objetivo",
    // Edit dialog
    editDialog: {
      title: "Editar Empresa",
      description: "Actualiza la información y configuración de la empresa.",
      industry: "Industria",
      selectIndustry: "Seleccionar industria",
      notSpecified: "No especificado",
      contactEmail: "Correo de Contacto",
      status: "Estado",
      selectStatus: "Seleccionar estado",
      archived: "Archivada",
      hoursPurchased: "Horas Compradas",
      startDate: "Fecha de Inicio",
      targetCompletion: "Fecha Objetivo",
      currentPhase: "Fase Actual",
      selectPhase: "Seleccionar fase",
      notSetPhase: "No establecida",
    },
    // Tabs
    projectsTab: "Proyectos",
    brandTab: "Marca",
    socialTab: "Social",
    scopingTab: "Alcance",
    discoveryTab: "Descubrimiento",
    noProjectsForCompany: "Sin proyectos aún",
    createProjectHint: "Crea un proyecto para comenzar a rastrear trabajo para esta empresa.",
    manageBrandAssets: "Gestionar Activos de Marca",
    brandAssetsHint: "Edita las guías de marca, colores, tipografía e identidad visual de esta empresa.",
    manageSocialMedia: "Gestionar Redes Sociales",
    socialMediaHint: "Crea y programa contenido de redes sociales para esta empresa.",
    // Service request
    serviceRequest: "Solicitud de Servicio",
    serviceRequestCreatedFrom: "Esta empresa fue creada desde una solicitud de servicio",
    submitted: "Enviada",
    viewRequest: "Ver Solicitud",
    profile: {
      title: "Perfil de Empresa",
      subtitle: "Ver y gestionar información de la empresa",
      notLinked: "Cuenta No Vinculada",
      notLinkedDesc: "Tu cuenta aún no está vinculada a un perfil de empresa. Contacta a soporte para completar la configuración.",
      goToRequests: "Ir a Mis Solicitudes",
      noCompanies: "No se encontraron empresas.",
      selectCompany: "Seleccionar empresa",
      companyInfo: "Información de Empresa",
      editDetails: "Editar Detalles",
      contactEmail: "Correo de Contacto",
      created: "Creada",
      serviceHours: "Horas de Servicio",
      purchased: "Compradas",
      used: "Usadas",
      remaining: "Restantes",
      unlimited: "Ilimitadas",
      notAvailable: "N/D",
      usage: "Uso",
      quickLinks: "Enlaces Rápidos",
      brandAssets: "Activos de Marca",
      brandAssetsDesc: "Logos, colores, tipografía",
      executions: "Ejecuciones",
      executionsDesc: "Tareas y entregables",
      socialMedia: "Redes Sociales",
      socialMediaDesc: "Contenido y programación",
      addTag: "Agregar etiqueta...",
      noTags: "Sin etiquetas",
      loading: "Cargando perfil de empresa",
      companyName: "Nombre de Empresa",
    },
  },
};
